import { ReactNode } from 'react';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@e2n/ui/v2';
import {
  faCircleQuestion,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIsMobile } from '@/hooks/useIsMobile';

type InfoButtonProps = {
  children: ReactNode;
  ariaLabel?: string;
  icon?: IconDefinition;
};

export function InfoButton({
  children,
  ariaLabel = 'Info',
  icon = faCircleQuestion,
}: InfoButtonProps) {
  const isMobile = useIsMobile();

  const trigger = (
    <button
      type="button"
      aria-label={ariaLabel}
      className="inline-flex items-center text-primary-blue-500">
      <FontAwesomeIcon icon={icon} />
    </button>
  );

  if (isMobile) {
    return (
      <Popover>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent>
          <PopoverBody className="text-sm">{children}</PopoverBody>
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{trigger}</TooltipTrigger>
      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  );
}
